(function eventBus(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  const previousEventBus = global.NewHomeSource.EventBus;

  /**
   * @constructs NewHomeSource.EventBus
   */
  const EventBus = function EventBus() {
    this.observers = [];
  };

  /**
   * @public
   * addObserver: adds a new Observer to the Event bus for the given topic.
   *
   * @param {string} topic to identify the data needed for the observer.
   * @param {function} observer function to be called when the topic has changed.
   */
  EventBus.prototype.addObserver = function addObserver(topic, observer) {
    if ((typeof observer !== 'function' && typeof observer !== 'object') || typeof topic !== 'string') {
      return;
    }

    if (!Array.isArray(this.observers[topic])) {
      this.observers[topic] = [];
    }

    this.observers[topic].push(observer);
  };

  /**
   * @public
   * notifyObservers: notifies the obsevers listening to the given topic and pass the given data.
   *
   * @param {string} topic to identify the observers to be notified.
   * @param {object} data to be passed to the observers.
   */
  EventBus.prototype.notifyObservers = function notifyObservers(topic, data) {
    if (typeof topic !== 'string') {
      return;
    }

    if (!Array.isArray(this.observers[topic])) {
      return;
    }

    const totalCallbacks = this.observers[topic].length;

    for (let i = 0; i < totalCallbacks; i += 1) {
      const fn = this.observers[topic][i];

      if (typeof fn.update === 'function') {
        fn.update(data, topic);
      }
    }
  };

  /**
   * @public
   * removeObserver: removes an Observer to the Event bus for the given topic.
   *
   * @param {string} topic to identify the data requested for the observer.
   * @param {function} observer function to be removed from the given topic.
   */
  EventBus.prototype.removeObserver = function removeObserver(topic, observer) {
    if ((typeof observer !== 'function' && typeof observer !== 'object') || typeof topic !== 'string') {
      return;
    }

    if (!Array.isArray(this.observers[topic])) {
      return;
    }

    const index = this.observers[topic].indexOf(observer);

    if (index >= 0) {
      this.observers[topic].splice(index, 1);
    }
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.FullImageViewer to the previous script.
   */
  EventBus.noConflict = function noConflict() {
    global.NewHomeSource.EventBus = previousEventBus;
    return EventBus;
  };

  global.NewHomeSource.EventBus = EventBus;
}(window));

define("eventBus", function(){});

